<template>
    <div class="monitor">
        <monitor-top></monitor-top>
        <div class="monitor-main-b">
            <monitor-left-b></monitor-left-b>
        </div>
    </div>
</template>

<script>
import MonitorTop from './partials/MonitorTop'
import MonitorLeftB from './partials/MonitorLeftB'

export default {
    name: "MonitorB",
    components: {
        MonitorTop,
        MonitorLeftB,
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    computed: {

    },
    methods:{

    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/views/monitor/index_b.vue